import { PropsWithChildren } from 'react';
// eslint-disable-next-line @wyz/module/no-relative-import
import { CustomerSelectorAvailabilityContext } from './contexts';

export function CustomerSelectorAvailabilityProvider({
  children,
}: PropsWithChildren) {
  return (
    <CustomerSelectorAvailabilityContext.Provider value={true}>
      {children}
    </CustomerSelectorAvailabilityContext.Provider>
  );
}
